import { SiteLayout } from '../../components/SiteLayout';
import { usePageMeta } from '../../lib/meta';

export function NotFound() {
  usePageMeta('Page not found', 'This page does not exist.');
  return (
    <SiteLayout>
      <div class="container page-hero center notfound">
        <h1>Page not found</h1>
        <p class="muted">The page you’re looking for doesn’t exist or has moved.</p>
        <a class="btn primary" href="/">Go to home</a>
      </div>
    </SiteLayout>
  );
}
